<template>
<div id="dealer-search">
  <router-view :loaded="loaded" v-if="loaded">
  </router-view>
</div>
</template>

<script>


//const topics = [{id:0, name:'Allgemein'}, {id:1, name:'Vermietung'},{id:2, name:'Verkauf'},{id:3, name:'Service'}];

import PrepareFilter from './utils/PrepareFilter'
import {
  i18n
}
from './plugins/i18n.js'
import {
  mapState,
} from 'vuex'

export default {
  name: 'app',
  components: {

  },
  data: function() {
    return {
      user: {},
      loaded: false,
      from: null,
      searchstring: null,
      mfilter: {}
    }
  },
  computed: {
    allTopics() {
      return this.$store.state.summery.allTopics;
    }
  },
  created: function() {

    const mountEl = document.querySelector('#dealer-search');


    if (mountEl && mountEl.dataset){


    if(mountEl.dataset['lang'] != undefined) {
      //let languages = ['de', 'en', 'fr'];
      i18n.locale = mountEl.dataset['lang'];
      this.language = mountEl.dataset['lang'];
    } else {
        i18n.locale = 'de';
    }


    if(mountEl.dataset.country && mountEl.dataset.country != ''){

      let country = mountEl.dataset.country.toUpperCase();

      this.$store.commit('summery/address', null);
      this.$store.commit('summery/country', country);
      this.$store.commit('summery/fetchList', true);
        this.$router.push({
            path: '/l'
          }
        );
    }

    if(mountEl.dataset.location && mountEl.dataset.location != ''){

      let location = mountEl.dataset.location.split("/");

      this.$store.dispatch('summery/availableVehicles', {
        lat: location[0],
        lng: location[1],
        distance: location[2],
        filter: this.filter
      }).then((x)=>{
        this.$router.push({
            path: '/l'
          }
        );
      });

    }

    if(mountEl.dataset.searchstring && mountEl.dataset.searchstring != ''){
      this.searchstring = mountEl.dataset.searchstring;
      let t = this.searchstring.split("&");
      for(let index in t){
        let p = t[index].split("=");
        PrepareFilter(this.mfilter, {'name':p[0], 'operator': "=", 'value': p[1]});
      }
      this.$store.commit('summery/setFilter', this.mfilter);
      this.$store.commit('summery/fetchList', true);
      this.$router.push({
          path: '/l'
        }
      );
    }


    this.$store.commit('summery/topics', this.allTopics);
    this.$store.commit('summery/topic', 0);

    if (mountEl.dataset.topic != null && mountEl.dataset.topic != "") {

      let tp = [];
      tp.push(this.allTopics[mountEl.dataset.topic]);

      this.$store.commit('summery/topics', tp);
      this.$store.commit('summery/topic', mountEl.dataset.topic);

    }

    if (mountEl.dataset.sec != null) {
      this.user.sec = mountEl.dataset.sec;
    }
  }


  /*
  var pathArray = window.location.pathname.split('/');
  var secondLevelLocation = pathArray[1];


    if (secondLevelLocation == "de" || secondLevelLocation == "en" || secondLevelLocation == "fr") {
      i18n.locale = secondLevelLocation;
    } else {
      i18n.locale = "de";
    }
    */

    this.loaded = true;
  },
  methods: {


  }

}
</script>

<style>

.blackoutline{
  border: 2px solid #333333;
  height: 49px;
}

.trike {
  min-width: 35px;
    margin-bottom: -2px!important;
    background-repeat: no-repeat;
    -webkit-transform: scale(1.2);
    transform: scale(1.12);
  opacity: 0.6!important;
  background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!-- Generator: Adobe Illustrator 14.0.0, SVG Export Plug-In --%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd' %5B %3C!ENTITY ns_flows 'http://ns.adobe.com/Flows/1.0/'%3E%0A%5D%3E%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:a='http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/' x='0px' y='0px' width='34px' height='14px' viewBox='-0.441 -0.094 34 14' enable-background='new -0.441 -0.094 34 14' xml:space='preserve'%3E%3Cdefs%3E%3C/defs%3E%3Cpath fill='none' d='M29.549,11.89c-0.408-0.088-0.795-0.298-1.13-0.578C28.757,11.591,29.147,11.792,29.549,11.89z'/%3E%3Cpath fill='none' d='M28.31,11.22c-0.323-0.302-0.593-0.678-0.737-1.133C27.717,10.542,27.983,10.921,28.31,11.22z'/%3E%3Cpath fill='none' d='M3.512,9.991C3.486,9.886,3.438,9.797,3.445,9.677C3.433,9.863,3.468,9.939,3.512,9.991z'/%3E%3Cpath fill='none' d='M31.35,6.482c2.349,1.033,1.944,4.701-0.564,5.337C33.421,11.197,33.715,7.521,31.35,6.482z'/%3E%3Cpath fill='%23FFFFFF' d='M8.038,2.705C8.157,2.242,8.4,1.594,8.389,1.192c-0.31,0.525-0.704,0.964-0.99,1.512 C7.612,2.705,7.824,2.705,8.038,2.705z'/%3E%3Cpath fill='%23FFFFFF' d='M22.397,2.355c0.215-0.229,0-0.687-0.232-0.813C22.174,1.671,22.242,2.185,22.397,2.355z'/%3E%3Cpath fill='%23FFFFFF' d='M22.806,2.877c0.496,0.415,1.5,0.63,1.977,0.873C24.382,3.239,23.514,2.887,22.806,2.877z'/%3E%3Cpath fill='%23FFFFFF' d='M24.259,4.158c0.162-0.09,0.271-0.234,0.405-0.058c0.041-0.311-0.174-0.366-0.35-0.464 C24.367,3.845,24.063,3.996,24.259,4.158z'/%3E%3Cpath fill='%23FFFFFF' d='M11.934,4.158c-0.126-0.204-0.652-0.314-0.873-0.232C11.344,4.012,11.623,4.1,11.934,4.158z'/%3E%3Cpath fill='%23FFFFFF' d='M26.467,6.19c0.191,0.042,0.527,0.318,0.582,0C26.778,6.23,26.635,5.932,26.467,6.19z'/%3E%3Cpath fill='%23FFFFFF' d='M26.407,6.89c0.115-0.116,0.275-0.189,0.352-0.349c-0.146-0.048-0.313-0.076-0.524-0.058 C26.273,6.637,26.325,6.778,26.407,6.89z'/%3E%3Cpath fill='%23FFFFFF' d='M25.014,7.47c0.175,0,0.35,0,0.522,0C25.521,7.217,25.098,7.419,25.014,7.47z'/%3E%3Cpath fill='%23FFFFFF' d='M30.072,7.587c-0.3-0.042-0.465,0.275-0.408,0.407C29.869,8.129,30.154,7.927,30.072,7.587z'/%3E%3Cpath fill='%23FFFFFF' d='M30.421,7.587c0,0.115,0,0.23,0,0.35c0.314,0.032,0.543,0.328,0.87,0.174 C31.17,7.767,30.846,7.627,30.421,7.587z'/%3E%3Cpath fill='%23FFFFFF' d='M25.071,8.458c0.032-0.298,0.104-0.555,0.232-0.756c-0.259,0.012-0.396,0.15-0.522,0.292 C24.938,8.088,24.824,8.454,25.071,8.458z'/%3E%3Cpath fill='%23FFFFFF' d='M24.315,8.168c-0.29,0.021-0.476,0.144-0.813,0.117c-0.234,0.249-0.396,0.569-0.641,0.813 c-0.413-0.02-1.146,0.232-0.93,0.463c1.018,0.067,2.118,0.31,2.85-0.115C24.691,8.958,24.428,8.638,24.315,8.168z'/%3E%3Cpath fill='%23FFFFFF' d='M31.641,9.333c0.132-0.308,0.023-0.826-0.174-0.99C31.254,8.568,31.513,9.085,31.641,9.333z'/%3E%3Cpath fill='%23FFFFFF' d='M2.574,8.691c0.341,0.078,0.632,0.172,0.871-0.059C3.13,8.708,2.733,8.411,2.574,8.691z'/%3E%3Cpath fill='%23FFFFFF' d='M24.49,9.795c0.258-0.042,0.535,0.198,0.698,0.058c-0.234,0.041-0.144-0.244-0.35-0.23 C24.765,9.722,24.491,9.624,24.49,9.795z'/%3E%3Cpath fill='%23FFFFFF' d='M30.886,10.32c0.26,0.024,0.549-0.418,0.696-0.698C31.266,9.769,31.122,10.094,30.886,10.32z'/%3E%3Cpath fill='%23FFFFFF' d='M29.607,10.495c0.244,0.028,0.847,0.18,0.987-0.058C30.254,10.457,29.659,10.064,29.607,10.495z'/%3E%3Cpath fill='%23FFFFFF' d='M26.699,6.366c-0.189-0.107-0.627-0.151-0.696-0.057C26.151,6.375,26.623,6.418,26.699,6.366z'/%3E%3Cpath fill='%23FFFFFF' d='M28.791,9.678c0.094,0.298,0.31,0.468,0.523,0.642C29.458,9.974,28.905,9.95,28.791,9.678z'/%3E%3Cpath d='M31.35,6.482c0.155-0.002,0.343,0.033,0.35-0.117c-0.843-0.476-2.674-0.501-3.372,0.117 c-0.238-0.244-0.613-0.354-0.522-0.931c0.153,0,0.333,0.023,0.408-0.057c0.085-0.234,0.185-0.598,0.059-0.872 c-0.331-0.116-0.584-0.309-1.104-0.234C27,4.513,26.851,4.652,26.762,4.854c-0.409-0.403-0.855-1.329-1.515-1.105 c-0.403-0.916-1.772-1.166-2.613-1.453c0.045-0.435-0.211-0.565-0.234-0.93c-0.353,0.005-0.416-0.282-0.639-0.407 c-0.087,0.407-0.128,0.01-0.465,0.058c-0.127,0.13-0.178,0.564-0.061,0.756c0.22,0.027,0.273-0.115,0.408-0.174 c0.003,0.329,0.23,0.201,0.407,0.116c0.074,0.253,0.104,0.292,0.058,0.582c-0.318-0.127-0.756,0.082-0.93,0.29 c0,0.232,0.292,0.173,0.521,0.175c-0.129,0.122-0.012,0.259,0.06,0.349c0.357-0.023,0.748,0.128,1.104-0.117 c0.222,0.245,0.6,0.332,0.872,0.523c-0.151,0.158-0.208,0.414-0.29,0.639c0.275,0.15,0.687,0.167,0.755,0.524 c-0.644-0.289-1.16,0.077-1.686,0.174c-0.063-0.209-0.089-0.453-0.291-0.524c-0.104-0.005-0.183,0.013-0.233,0.058 c-0.032,0.402,0.375,0.363,0.465,0.641c-0.797,0.383-1.333,1.326-1.976,2.034c-0.297-0.718-1.304-0.02-1.861,0.058 c-0.492-0.728-1.146-1.293-1.857-1.801c-0.267-0.781-0.446-1.647-1.105-2.035c-0.201,0.108-0.349,0.27-0.29,0.639 c-0.854-0.082-0.536,1.812-0.06,2.093c-0.346-0.035-0.519,0.102-0.871,0.058c0.105-0.263-0.209-0.1-0.234-0.232 c0-0.135,0-0.271,0-0.407c-0.334-0.367-0.931-0.023-1.453-0.058c-0.094-0.488-0.167-0.996-0.522-1.222 c0.178,0.041,0.213-0.06,0.35-0.058c0.25,0.254,0.321,0.687,0.407,1.105c0.713-0.501-0.105-1.362-0.407-1.743 c-0.648-0.071-1.231-0.504-1.919-0.35C10.629,2.304,9.245,2.017,9.26,2.876C9.082,2.803,8.741,2.893,8.679,2.705 C8.872,2.183,8.856,1.447,9.086,0.96C9.19,1.166,9.225,1.442,9.435,1.542c0.815,0.084,0.682-1.067,0.407-1.454 C9.547-0.061,9.199-0.044,9.145,0.319C9.134,0.156,9.041,0.072,8.853,0.087c-0.145,0.11-0.218,0.287-0.233,0.524 c-0.81,0.43-1.08,1.399-1.687,2.034C5.851,2.607,4.935,2.738,3.911,2.762C3.891,2.589,3.818,2.467,3.737,2.355 c-1.052,0.043-1.821-0.5-2.849-0.291c0.003,0.675,0.375,0.981,0.813,1.222C1.563,3.395,1.364,3.812,1.587,3.924 C1.357,3.93,1.224,4.026,1.063,4.1C1.031,4.515,0.925,4.853,0.947,5.32c-0.29-0.004-0.521,0.205-0.814,0.348 C-0.401,6.85,0.89,7.656,0.247,8.633C0.86,9.329,2.146,8.835,2.632,9.738C2.965,9.779,3.15,9.674,3.444,9.677 C3.437,9.796,3.485,9.886,3.511,9.991c0.036,0.044,0.082,0.071,0.125,0.118c0.007,1.712,1.395,3.097,3.106,3.097 c1.439,0,2.642-0.984,2.996-2.315c0.202,0.126,0.14,0.212,0.381,0.162c1.125-0.292,2.813-0.515,4.372-0.561h0.291 c0.801,0.148,1.872,0.019,2.733,0.23c0.163-0.009,0.073-0.277,0.29-0.23c0.707,0.043,1.479,0.035,2.383,0 c1.71-0.071,3.617,0.389,5.175,0.465c0.899,0.044,1.519,0.013,1.859-0.641c-0.945,0.057-1.174-0.607-1.859-0.813 c-0.403-0.758,0.189-1.895,1.104-1.861c-0.024-0.243,0.216-0.542-0.059-0.696c0.271-0.062,0.307-0.356,0.581-0.408 c0.335,0.092,0.657,0.197,0.641,0.641c-0.418,0.615-0.686,1.602-0.522,2.615c0.127,0.125,0.344,0.16,0.465,0.292 c0.146,0.455,0.414,0.831,0.737,1.133c0.037,0.032,0.073,0.063,0.106,0.093c0.335,0.279,0.724,0.489,1.132,0.576 c0.458,0.049,0.867,0.016,1.235-0.068C33.294,11.183,33.698,7.515,31.35,6.482z M22.397,2.355c-0.153-0.171-0.224-0.684-0.232-0.813 C22.397,1.668,22.612,2.126,22.397,2.355z M2.574,8.691c0.158-0.28,0.557,0.017,0.871-0.059C3.206,8.863,2.914,8.769,2.574,8.691z M6.726,11.017c-0.438,0-0.791-0.377-0.791-0.843c0-0.467,0.354-0.844,0.791-0.844c0.436,0,0.79,0.377,0.79,0.844 C7.516,10.64,7.159,11.017,6.726,11.017z M8.038,2.705c-0.215,0-0.427,0-0.641,0c0.287-0.548,0.682-0.987,0.99-1.512 C8.401,1.594,8.157,2.242,8.038,2.705z M11.062,3.924c0.221-0.082,0.746,0.028,0.873,0.232C11.623,4.1,11.344,4.012,11.062,3.924z M22.806,2.877c0.708,0.01,1.576,0.362,1.977,0.873C24.306,3.507,23.302,3.292,22.806,2.877z M24.314,3.635 c0.176,0.097,0.39,0.153,0.349,0.464c-0.135-0.176-0.243-0.032-0.405,0.058C24.063,3.996,24.366,3.844,24.314,3.635z M21.933,9.564 c-0.217-0.229,0.518-0.481,0.93-0.465c0.243-0.244,0.405-0.563,0.639-0.813c0.34,0.025,0.524-0.098,0.813-0.117 c0.112,0.469,0.376,0.789,0.467,1.277C24.051,9.873,22.949,9.631,21.933,9.564z M24.49,9.795c0.001-0.172,0.274-0.073,0.351-0.174 c0.206-0.013,0.113,0.272,0.35,0.231C25.025,9.995,24.747,9.753,24.49,9.795z M25.071,8.458c-0.247-0.005-0.133-0.37-0.29-0.464 c0.128-0.142,0.265-0.28,0.522-0.292C25.176,7.904,25.104,8.161,25.071,8.458z M25.014,7.47c0.084-0.051,0.508-0.253,0.522,0 C25.363,7.47,25.188,7.47,25.014,7.47z M26.699,6.366c-0.076,0.053-0.549,0.01-0.696-0.057C26.073,6.213,26.51,6.258,26.699,6.366z M26.407,6.89c-0.082-0.11-0.135-0.251-0.174-0.407c0.212-0.018,0.378,0.01,0.524,0.058C26.684,6.701,26.524,6.773,26.407,6.89z M26.467,6.19c0.168-0.26,0.312,0.039,0.582,0C26.993,6.508,26.658,6.233,26.467,6.19z M31.641,9.296 c-0.001,0.009,0.006,0.025,0,0.036c-0.001-0.002-0.001-0.005-0.003-0.009c-0.017,0.104-0.027,0.207-0.063,0.304 c0.003,0,0.003-0.003,0.007-0.005c-0.002,0.003-0.007,0.009-0.009,0.011c-0.214,0.604-0.772,1.042-1.451,1.042 c-0.858,0-1.554-0.695-1.554-1.555c0-0.366,0.131-0.698,0.342-0.964l0.62,0.679c-0.039,0.087-0.064,0.182-0.064,0.284 c0,0.364,0.271,0.659,0.605,0.659s0.606-0.295,0.606-0.659S30.406,8.46,30.071,8.46c-0.003,0-0.005,0.002-0.008,0.002L29.4,7.75 c0.217-0.114,0.46-0.185,0.722-0.185c0.106,0,0.197,0.039,0.298,0.06c0-0.013,0-0.024,0-0.036c0.362,0.033,0.626,0.169,0.776,0.415 c0.024,0.022,0.042,0.051,0.065,0.076c0.005,0.013,0.021,0.019,0.026,0.032c-0.001,0.002-0.003-0.002-0.007,0 c0.071,0.08,0.126,0.17,0.18,0.264c0.007-0.009-0.005-0.025,0.003-0.033c0.028,0.024,0.037,0.092,0.063,0.131 c0.012,0.024,0.023,0.045,0.035,0.07c0.073,0.146,0.103,0.299,0.096,0.489c0.001,0.03,0.021,0.055,0.021,0.087 C31.678,9.183,31.649,9.236,31.641,9.296z'/%3E%3C/svg%3E%0A");
}

select.form-control {
    margin-top: 0px;
    border-radius: 4px;
    border: 1px solid #949494;
    background-color: #eee;
    height: 38px;
}

input.form-control {
  border-radius: 4px;
  border: 1px solid #949494;
  background-color: #eee;
  height: 38px;
}

.large-trikelist {
    margin-top: 20px;
}



.button{
  border-radius: 0px!important;

}
input:focus {
    outline: none !important;
    box-shadow: none !important;
}

.search-result-header {
    background-color: #efefef;
    padding-top: 10px;
    padding-bottom: 10px;
    min-height: 70px;
}

.large-trikebox {
    margin-bottom: 20px;
    border: 1px solid #eeeeee;
    border-color: #d6d6d6 !important;
    background-color: #f7f7f7;
}

.ui.input>input {
  padding: .67857143em 0.7em !important;
}

.ui.label {

  padding: 0.4em;
  background-color: #f7f7f7;
}

.ui.tag.label:before, .ui.tag.labels .label:before {

    width: 1.08em;
    height: 1.08em;
}

.ui.tag.label, .ui.tag.labels .label {
    border-radius: 0 .18571429rem .18571429rem 0;
}

a{
  color: #c51a1b;
}
a:hover{
  color: #c51a1b;
  cursor:pointer;
}
.service-lable {
    color: black;
    font-family: Anton,sans-serif;
    margin-right: 5px;
    font-size: 0.74em;
    letter-spacing: 1px;
    display: inline-block;
    min-width: 96px;
    cursor: auto;
    white-space: nowrap;
    overflow: hidden;
    text-align: left;
    padding-left: 4px;
    text-overflow: ellipsis;
}

h1, h2, h3{
  font-family: Anton,sans-serif;
letter-spacing: 1px;
text-transform: uppercase;
font-weight: 500;
line-height: 1.1;
color:black;
}

.content-top-btn {
    background-color: #c51a1b;
    position: fixed;
    width: 50px;
    height: 50px;
    bottom: 0;
    right: 0;
    z-index: 999;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.component-fade-enter-active, .component-fade-leave-active {
  transition: opacity .3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.large-trikebox{
  height: 100%;
  margin-bottom: 0px;
}

.rcontainer {
  min-height: 190px;
}

.vcomponent{
  min-height: 262px;
  margin-bottom: 20px;
}

.rservices{
  float: right;
}

.listsubmenu{
    margin-bottom: 10px;
    margin-top: 10px;
}

.ad-nr{
  margin-top: 12px;
  text-align: right;
}

.vue-slider-dot {
    z-index: 2!important;
}


@media only screen and (max-width: 1000px) {

  .rcontainer {
    min-height: 0px;
  }
  .rservices{
    float: right;
  }
  .vcomponent{
    min-height: 280px;
  }

}

@media only screen and (max-width: 772px) {
  .rcontainer {
    min-height: 0px;
  }
  .rservices{
    float: left;
    width: 100%;
  }
  .vcomponent{
    min-height: 622px;
  }
  .listsubmenu{
      margin-top: 18px;
  }
  .ad-nr{
    text-align: left;
  }

}


.inset{
  margin-left: 15px;
  margin-right: 15px;
}


@media only screen and (max-width: 410px) {


  .mx-datepicker-popup{
    display: none!important;
  }
/*
  .mx-input{
    pointer-events: none!important;
  }
  */
}

.service-lable {
           color: black;
           font-family: Anton,sans-serif;
           margin-right: 5px;
           font-size: 0.74em;
           letter-spacing: 1px;
           display: inline-block;
           min-width: 96px;
           cursor: auto;
           white-space: nowrap;
           overflow: hidden;
           text-align: left;
           padding-left: 4px;
           text-overflow: ellipsis;
       }

       @media only screen and (max-width: 790px) {
           .ap{
               float:right;
               margin-bottom: 5px;
           }
           .aq{
               text-align: left;
           }
       }

       .owl-nav i {
           font-size: 30px;
            background-color: #c51a1b !important;
           color: white;
           width: 100%;
           height: 100%;

       }
       .owl-nav i:before {
         margin-top: 0px;
         padding-top: 0px;
         padding-bottom: 0px;
       }
       .owl-nav {

           margin: 0px;

       }

       .owl-dots {
           margin: 15px 0 0 0;
           transform: none;
           text-align: center;
       }


       .owl-prev {
           color: #FFF;
           background: none !important;
           margin-left: 0px!important;
       }


       .owl-next {
           color: #FFF;
           background: none !important;
           margin-right: -3px !important;
       }

       .owl-theme .owl-dots .owl-dot.active span, .owl-theme .owl-dots .owl-dot:hover span {
           background: #c51a1b!important;
       }

       .ui.icon.input>i.icon {

         width: 1.3em;
       }


       .ui.message {
           position: relative;
           min-height: 1em;
           margin: 1em 0;
           background: #f8f8f9;
           padding: 1em 1.5em;
           line-height: 1.4285em;
           color: rgba(0,0,0,.87);
           -webkit-transition: opacity .1s ease,color .1s ease,background .1s ease,-webkit-box-shadow .1s ease;
           transition: opacity .1s ease,color .1s ease,background .1s ease,-webkit-box-shadow .1s ease;
           transition: opacity .1s ease,color .1s ease,background .1s ease,box-shadow .1s ease;
           transition: opacity .1s ease,color .1s ease,background .1s ease,box-shadow .1s ease,-webkit-box-shadow .1s ease;
           border-radius: .28571429rem;
           -webkit-box-shadow: 0 0 0 1px rgba(34,36,38,.22) inset, 0 0 0 0 transparent;
           box-shadow: 0 0 0 1px rgba(34,36,38,.22) inset, 0 0 0 0 transparent;
       }

       .tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: #f7f7f7;
  color: rgba(0,0,0,.6);
  border-radius: 8px;
  font-weight: 700;
  padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: #f7f7f7;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, .1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity .15s, visibility .15s;
}

.tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity .15s;
}






</style>
